import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getFactorsAffectingCareSelector } from '../selectors/getFactorsAffectingCare.selector'
import { setFactorsAffectingCareState } from '../store/factorsAffectingCare.actions'
import { FactorsAffectingCareConstants } from '../store/factorsAffectingCare.constants'
import { IFactorsAffectingCareState } from '../store/factorsAffectingCare.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getFactorsAffectingCare() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const factorsAffectingCareState: IFactorsAffectingCareState = yield select(getFactorsAffectingCareSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const factorsAffectingCare = pcrDoc.factorsAffectingCareState
      if (factorsAffectingCare && Object.keys(factorsAffectingCare).length !== 0) {
        const factorsAffectingCareUpdated: IFactorsAffectingCareState = {
          dispatchFactors: factorsAffectingCare.dispatchFactors,
          dispatchFactorsPNNV: factorsAffectingCare.dispatchFactorsPNNV,
          sceneFactors: factorsAffectingCare.sceneFactors,
          sceneFactorsPNNV: factorsAffectingCare.sceneFactorsPNNV,
          responseFactors: factorsAffectingCare.responseFactors,
          responseFactorsPNNV: factorsAffectingCare.responseFactorsPNNV,
          transportFactors: factorsAffectingCare.transportFactors,
          transportFactorsPNNV: factorsAffectingCare.transportFactorsPNNV,
          turnAroundFactors: factorsAffectingCare.turnAroundFactors,
          turnAroundFactorsPNNV: factorsAffectingCare.turnAroundFactorsPNNV,
          factors: factorsAffectingCare.factors,
          showFactors: factorsAffectingCareState.showFactors,
          showDispatchFactors: factorsAffectingCareState.showDispatchFactors,
          showTurnAroundFactors: factorsAffectingCareState.showTurnAroundFactors,
          showResponseSceneTransportFactors: factorsAffectingCareState.showResponseSceneTransportFactors,
        }
        yield put(setFactorsAffectingCareState(factorsAffectingCareUpdated))
      }
    } catch (e) {
      yield put(throwPcrException(`getFactorsAffectingCare() error: ${e}`))
    }
  }
}

export function* getFactorsAffectingCareSaga() {
  yield takeLatest(
    [FactorsAffectingCareConstants.GET_FACTORS_AFFECTING_CARE_STATE],
    performWithMutexHOG,
    getFactorsAffectingCare
  )
}
